export const GOOGLE_ADS_TARGETING_KEY_NEW_CAR_PROMOTION = 'TacticalAdsPromoID';
export const GOOGLE_ADS_TARGETING_KEY_NEW_CAR_COMPETITOR = 'TacticalAdsCompID';

export const PROMOTION_MODEL_PI_COVER_IMAGE_WIDTH = 320;
export const PROMOTION_MODEL_PI_COVER_IMAGE_HEIGHT = 180;

export const PROMOTION_DESKTOP_BANNER_IMAGE_WIDTH = 569;
export const PROMOTION_DESKTOP_BANNER_IMAGE_HEIGHT = 354;

export const PROMOTION_DEALER_INFO_ICON_SIZE = 16;

export const PROMOTION_MORE_PROMOS_ICON_SIZE = 9;

export const PROMOTION_POSTED_ON_DATE_FORMAT = 'DD-MMM-YYYY';
